<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";

const noteSections = [
  { title: "Prose Notes", to: "/11th/english/prose/", description: "Prose units ke chapter-wise notes aur explanations." },
  { title: "Poems Notes", to: "/11th/english/poems/", description: "Poems ke central ideas, tone, imagery aur explanation." },
  { title: "Play Notes", to: "/11th/english/play/", description: "The End of the Beginning ki summary, characters aur themes." },
  { title: "Grammar & Composition", to: "/11th/english/grammar/", description: "Grammar aur composition ke important topics." },
];

const faqs = [
  {
    question: "What kinds of notes are linked from this page?",
    answer: "Yeh page prose, poems, play aur grammar/composition ke notes tak le jata hai.",
  },
  {
    question: "Are these notes only summaries?",
    answer: "Nahi. Major literature pages me explanation, reading answers aur important points bhi milte hain.",
  },
  {
    question: "Where should I start if I want chapter-wise English notes?",
    answer: "Agar aap literature notes chahte hain to prose, poems ya play open karein. Grammar ke liye grammar section use karein.",
  },
];

usePageSeo({
  title: "11th Class English Notes | Chapter Wise Notes, Poems, Play, Grammar",
  description: "11th class English notes ke liye prose, poems, play aur grammar/composition ka chapter-wise page.",
  keywords: "11th class english notes, class 11 english notes, 1st year english notes, chapter wise english notes, prose notes, poem notes",
  schemaType: "CollectionPage",
  schemaProperties: {
    mainEntity: {
      "@type": "ItemList",
      itemListElement: noteSections.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.title,
        url: `https://ustaad.today${item.to}`,
      })),
    },
  },
  faqs,
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th English", item: "/11th/english/" },
    { name: "Notes", item: "/11th/english/notes/" },
  ],
});
</script>

<template>
  <PageContainer>
    <EnglishHero
      headline="11th Class English"
      title="11th Class English Notes"
      description="Yahan se aap prose, poems, play aur grammar ke notes khol sakte hain."
    />

    <EnglishSection
      title="Notes Sections"
      description="Jis type ke notes chahiye, woh section open karein."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="section in noteSections"
          :key="section.to"
          :title="section.title"
          :description="section.description"
          :to="section.to"
        />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection
      title="FAQs"
      description="Notes ke bare me chhote aur seedhe jawab."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="item in faqs"
          :key="item.question"
          :title="item.question"
          :description="item.answer"
        />
      </EnglishGrid>
    </EnglishSection>
  </PageContainer>
</template>
